module.exports = __webpack_public_path__ + "img/map-marker-01.a6a91172.svg";